import React from 'react'
import MyDiv from './JobWorkMood.style'
import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, DrawerFooter, FormControl, Button, Center, Spinner, Tag, TagCloseButton, TagLabel, } from "@chakra-ui/react";
import { ActionEditIcon, CustomButton, CustomToast, } from "../../../../../components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import PlusIcon from "../../../../../assets/images/Vector.svg"
import { useFetch } from '../../../../../hooks/useFetch';
import { useEffect, useState } from 'react';
import { HrlenseInput } from '../../../../../components/Input/Input';
import { emptyJobWorkMood, IJobWorkMood, schema } from './modal';
import CustomTable, { Column } from '../../../../../components/CustomTable/customTable';


const Header = [
    { id: 1, head: "S. No" },
    { id: 2, head: "Work Mood" },
    { id: 5, head: "Actions" },
];

export const JobWorkMood = () => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [isEditMode, setIsEditMode] = useState(false);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [jobWorkMoods, setJobWorkMoods] = useState<IJobWorkMood[]>([]);


    const { handleSubmit, control, formState: { errors }, reset, } = useForm<IJobWorkMood>({
        resolver: yupResolver(schema),
        defaultValues: emptyJobWorkMood,
        mode: "onBlur",
    });

    const onSubmit = async (data: IJobWorkMood) => {
        const method = isEditMode ? "PUT" : "POST";
        const response = await fetchApi("RecruitmentMaster/WorkMood", method, data, "", "");
        if (response) {
            addToast({ message: response.message, status: "success" })
            setDrawerOpen(false);
            reset(emptyJobWorkMood);
            loadJobWorkMood()
        }
    }

    const loadJobWorkMood = async () => {
        const response = await fetchApi("RecruitmentMaster/WorkMood", "GET", "", "", "");
        if (response) {
            setJobWorkMoods(response)
        }
    }

    const handleAddNewWorkMood = () => {
        setIsEditMode(false);
        reset(emptyJobWorkMood);
        setDrawerOpen(true);
    };

    const handleEditWork = (selections: IJobWorkMood) => {
        setIsEditMode(true);
        reset(selections);
        setDrawerOpen(true);
    };

    useEffect(() => {
        loadJobWorkMood();
    }, [])

    return (
        <MyDiv>
            <Box position="relative" minH="300px">
                {/* {loading ? (
                    <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                    </Center>
                ) : */}
                <>
                    <Flex className="page_heading flex_header">
                        <Text className="font-poppins text_semibold text_3xl">
                            Work Mood
                        </Text>
                        <Flex gap={2}>
                            
                            <CustomButton title="Add New Work Mood" className="btn font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} className="logo" />} onClick={handleAddNewWorkMood} />
                        </Flex>
                    </Flex>
                    <Grid className="grid_container">
                        <GridItem colSpan={12}>
                            <CustomTable value={jobWorkMoods} >
                              <Column header="S. No" body={(_, index) => index + 1} />
                              <Column header="Work Mood" field="work_Mood" />
                              <Column
                                header="Actions"
                                body={(row: any) => ( <ActionEditIcon onClick={() => handleEditWork(row)} />
                                )}
                              />
                            </CustomTable>

                        </GridItem>
                    </Grid>

                    <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="md">
                        <DrawerOverlay />
                        <DrawerContent>
                            <DrawerCloseButton />
                            <DrawerHeader borderBottomWidth="1px"> {isEditMode ? "Edit Work Mood" : "Add New Work Mood"}</DrawerHeader>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <DrawerBody>
                                    <Flex gap={8} mt={2}>
                                        <HrlenseInput isRequired label='Work Mood' name='work_Mood' control={control} placeholder='Enter Work Mood' errors={errors} />
                                    </Flex>
                                </DrawerBody>

                                <DrawerFooter>
                                    <Button variant="outline" mr={3} onClick={() => setDrawerOpen(false)} > Cancel</Button>
                                    <Button type="submit" bg="#006838" color="white" _hover={{ bg: "#00512a" }} > {isEditMode ? "Update Employment Type" : "Add New Employment Type"} </Button>
                                </DrawerFooter>
                            </form>
                        </DrawerContent>
                    </Drawer>
                </>

            </Box>
        </MyDiv>
    )
}
